









































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * API
 */
import authenticationAPI from '@/api/authentication';

/**
 * Types
 */
import { ResetPasswordRequest } from '@/api/authentication';

/**
 * Page de réinitialisation de mot de passe.
 */
@Component({ mixins: [mixinsAPI] })
export default class ResetPasswordPage extends Vue {
	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' }) openInfo: any;
	@Action('openError', { namespace: 'snackbar' }) openError: any;

	/** Attributs */
	isLoading = false;
	form = new ResetPasswordRequest();

	/** Méthodes */
	async handleSubmit() {
		this.isLoading = true;
		try {
			this.form.token = this.$route.query.token as string;
			await authenticationAPI.resetPassword(this.form);
			this.openInfo(this.$t('snackbar.success'));
			this.$router.push('/');
		}
		catch (err) {
			(this as any).handleAPIError(err);

		}
		this.isLoading = false;
	}
}
